import client from '@/http'

const load = (context) => {
  client.get(
    'tablecache'
  ).then(
    (res) => {
      context.commit('SET_CACHE', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const purge = (context, params) => {
  context.commit('SET_PURGING', params.key)

  client.put(
    `tablecache/${params.key}`
  ).then(
    () => {
      context.commit('SET_PURGING', null)
      // context.commit('REMOVE', params.key)
    }
  ).catch(
    e => {
      console.error(e)
    }
  )
}

export default {
  load,
  purge
}
